import { throttle } from 'lodash-es'

import { transformMusicData } from '../MusicList/_helpers/data'
import ScrollLyric from '../ScrollLyric'

import Banner from './_components/Banner'

import type { MusicListDataItem } from '../../ai-music-generator/_types/trpc'
import type { MusicMetadataSuccess } from '../MusicItem/_components/InternalMusicItem/_components/MusicItemSuccess'

import { useInWhichPage } from '@/hooks/useInWhichPage'


import { useGlobalAudioPlayer } from '@/hooks/audio/store';
import { useState, useEffect } from 'react';
import { api } from '@/utils/api';
import { cls } from 'tagged-classnames-free';
export default function MusicDetail(props: { data: MusicMetadataSuccess }) {
  const audioPlayer = useGlobalAudioPlayer()
  const { data: propsData } = props
  const { inDetailPage } = useInWhichPage()
  const globalAudioPlayer = useGlobalAudioPlayer()
  const [lyricTime, setLyricTime] = useState(0)
  const { data: { musicDetail } = {} } = api.music_v2.getMusicDetail.useQuery(
    {
      uuid: propsData.id,
    },
    {
      enabled: !inDetailPage,
    },
  )

  const data = musicDetail
    ? transformMusicData(musicDetail as MusicListDataItem, true)
    : propsData

  useEffect(() => {
    const unsubscribe = globalAudioPlayer.onTimeUpdate(
      throttle(setLyricTime, 500),
    )
    return () => unsubscribe()
  }, [data.lyricsLrc, globalAudioPlayer.howl])

  return (
    <div
      className={cls`
        bg-f-other-1 mx-auto flex h-[calc(100vh-64px)] w-full flex-col items-center justify-start gap-6 px-4
        pt-14 md:gap-20 md:px-6 md:pt-[72px] lg:flex-row lg:items-start lg:justify-center
        ${audioPlayer.collapsed ? 'pb-5' : 'pb-20'}
      `}
    >
      {!inDetailPage && (
        <span
          className={cls`
            i-cus--tad-down text-f-text-tertiary hover:text-f-text
            absolute left-0 top-0 ml-6 size-8 cursor-pointer
          `}
          onClick={() => audioPlayer.toggleShowDetail()}
        ></span>
      )}
      <Banner data={data} className={cls`w-full max-w-full md:max-w-[520px]`} />
      <ScrollLyric
        containerClassName={cls`scrollbar-none text-f-text-secondary mb-6 h-full w-[480px] space-y-4 overflow-y-auto whitespace-pre-wrap px-6 pb-12 text-center text-sm [mask-image:linear-gradient(to_bottom,white_0%,white_90%,transparent_100%)] xl:text-base`}
        lyricClassName={cls`transition-colors duration-300`}
        lyricsLrc={data.lyricsLrc}
        lyrics={data.lyrics}
        currentTime={lyricTime}
      />
    </div>
  )
}
